module.exports = __webpack_public_path__ + "static/media/video-play.1b62cdba.svg";